import { TbRefreshDot } from "react-icons/tb";
import { TextComponent } from "../../../components";
import styles from "./GuestVideo.module.css";
import { IoClose } from "react-icons/io5";
import { BiSolidMicrophone, BiSolidMicrophoneOff } from "react-icons/bi";
import { Row } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const GuestVideo = () => {
  const [micOn, setMicOn] = useState(true);
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <div className={styles.pinkBg}></div>
      <Row className={styles.textRow}>
        <TextComponent textClass={styles.text}>
          You & 34 Guests Are Watching
        </TextComponent>
      </Row>
      <Row className={styles.iconRow}>
        <TbRefreshDot className={styles.icon} />
        <div
          className={styles.closeIconBtn}
          onClick={() => navigate("/guestHome")}
        >
          <IoClose className={styles.icon} />
        </div>
        {micOn ? (
          <BiSolidMicrophone
            className={styles.icon}
            onClick={() => setMicOn(false)}
          />
        ) : (
          <BiSolidMicrophoneOff
            className={styles.icon}
            onClick={() => setMicOn(true)}
          />
        )}
      </Row>
    </div>
  );
};

export default GuestVideo;
